/**
 * Resource that represents a Inventory Confirmation type of Movement.
 *
 * @name MovementInventoryConfirmation
 * @class
 * @augments TmrResource
 */
function MovementInventoryConfirmationFactory(
  TmrResource,
  tmrMovementTypes,
  Place
) {
  'ngInject'
  let referencedProperties = [
    // movement.destinationPlace property will be instantiated as a Place resource
    { property: 'destinationPlace', resource: Place },
  ]
  let MovementInventoryConfirmation = TmrResource(
    'MovementInventoryConfirmation',
    {},
    referencedProperties
  )

  MovementInventoryConfirmation.getTypeDescription = getTypeDescription
  MovementInventoryConfirmation.prototype.$getTypeDescription =
    getTypeDescription

  /**
   * Return Movement type description.
   *
   * @method Movement#getTypeDescription
   */
  function getTypeDescription() {
    return tmrMovementTypes[this.type]
  }

  return MovementInventoryConfirmation
}

export const factory = [
  'MovementInventoryConfirmation',
  MovementInventoryConfirmationFactory,
]
